import type { LangDto } from "@client/common";

export const clientKeys = {
  base: () => ["clients"],
  productsContext: (patientId?: string) => [
    ...clientKeys.base(),
    "productsContext",
    patientId,
  ],
  recipesContext: (patientId?: string) => [
    ...clientKeys.base(),
    "recipesContext",
    patientId,
  ],
  list: (params?: string) =>
    params !== undefined
      ? [...clientKeys.base(), "list", params]
      : [...clientKeys.base(), "list"],
  forChat: (params?: string) =>
    params !== undefined
      ? [...clientKeys.base(), "forChat", params]
      : [...clientKeys.base(), "forChat"],
  detail: (id: number) => [...clientKeys.base(), id],
  usedRecipesBase: (id: number) => [...clientKeys.detail(id), "usedRecipes"],
  usedRecipes: (id: number, lang: LangDto) => [
    ...clientKeys.usedRecipesBase(id),
    lang,
  ],
  marketingConsent: (id: number) => [
    ...clientKeys.detail(id),
    "marketingConsent",
  ],
  events: (id?: string) =>
    id !== undefined
      ? [...clientKeys.base(), "events", id]
      : [...clientKeys.base(), "events"],
  eventsInfinite: (id: string, typeFilter?: string) => [
    ...clientKeys.events(id),
    "infinite",
    typeFilter ?? "",
  ],
  balance: (patientId?: string) =>
    patientId !== undefined
      ? [...clientKeys.base(), "balance", patientId]
      : [...clientKeys.base(), "balance"],
  tags: (id?: string) =>
    id ? [...clientKeys.base(), "tags", id] : [...clientKeys.base(), "tags"],
  foodPreferences: (id?: string, liked?: number) => {
    const key: (string | number)[] = [...clientKeys.base(), "foodPreferences"];
    if (id !== undefined) key.push(id);
    if (liked !== undefined) key.push(liked);
    return key;
  },
  foodGroupPreferences: (id?: string) =>
    id
      ? [...clientKeys.base(), "foodGroupPreferences", id]
      : [...clientKeys.base(), "foodGroupPreferences"],
  lastMeasurement: (id?: string) =>
    id
      ? [...clientKeys.base(), "lastMeasurement", id]
      : [...clientKeys.base(), "lastMeasurement"],
  measurementList: (id?: string) =>
    id
      ? [...clientKeys.base(), "measurementList", id]
      : [...clientKeys.base(), "measurementList"],
  measurementListInfinite: (id?: string) =>
    id
      ? [...clientKeys.base(), "measurementListInfinite", id]
      : [...clientKeys.base(), "measurementListInfinite"],
  measurementsChart: (id: string) => [
    ...clientKeys.base(),
    "measurementsChart",
    id,
  ],
  sources: () => [...clientKeys.base(), "sources"],
  targets: () => [...clientKeys.base(), "targets"],
  additionalFeatures: () => [...clientKeys.base(), "additionalFeatures"],
};
